import { Wrapper, Search, Separator, Total, Showing, Active, GridToggles } from '@/components/Grid/components/header/Heading';
import { DefaultGrid, GridProvider, useBuildGrid } from '@Components/Grid';

import { useBlacklistStore } from '../../store';
import BlacklistHeaderButtons from '../HeaderButtons';

import useColumns from './useColumns'
import useDefinitions from './useDefinitions'
import useEvents from './useEvents'
import useFilters from './useFilters'

function BlacklistGrid() {
  useBuildGrid({
    definitions: useDefinitions(),
    columns: useColumns(),
    filters: useFilters(),
    events: useEvents(),
  })

  return <DefaultGrid
    heading={<Wrapper>
      <Search />
      <Separator />
      <GridToggles />
      <Separator />
      <Total />
      <Showing />
      <Active />
      <Separator />
      <BlacklistHeaderButtons />
    </Wrapper>}
  />
}

export default function BlacklistGridLayout() {
  return <GridProvider store={useBlacklistStore()}>
    <BlacklistGrid />
  </GridProvider>
}
